import React from "react";
import { CardElement } from "@stripe/react-stripe-js";
import "./CardSectionStyles.scss";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#7e8e9e",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

function CardSection({ onChange }) {
  return <CardElement options={CARD_ELEMENT_OPTIONS} onChange={onChange} />;
}

export default CardSection;
